import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import Profile from "@/pages/Profile";

export const Route = createFileRoute("/en/account/profile")({
  head: () => ({
    meta: [
      { title: "My profile | Retail Lemon" },
      { name: "description", content: "Your business details, security and notifications." },
      { property: "og:title", content: "My profile | Retail Lemon" },
      { property: "og:description", content: "Business details, security and notifications." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <ProtectedRoute>
      <Profile />
    </ProtectedRoute>
  ),
});
